import React from 'react';
import { User, Settings, Heart, MapPin, CreditCard, Bell, HelpCircle, LogOut, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { useApp } from '../context/AppContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
export function ProfileScreen() {
  const {
    navigate,
    resetTo
  } = useNavigation();
  const {
    user,
    setUser,
    isVendorMode,
    toggleVendorMode
  } = useApp();
  const handleLogout = () => {
    setUser(null);
    resetTo(Screen.WELCOME);
  };
  const menuGroups = [{
    items: [{
      icon: Heart,
      label: 'My Wishlist',
      screen: Screen.WISHLIST
    }, {
      icon: MapPin,
      label: 'Address Book',
      screen: Screen.ADDRESS_BOOK
    }, {
      icon: CreditCard,
      label: 'Payment Methods',
      screen: Screen.PAYMENT_METHODS
    }]
  }, {
    items: [{
      icon: Bell,
      label: 'Notifications',
      screen: Screen.NOTIFICATIONS
    }, {
      icon: Settings,
      label: 'Settings',
      screen: Screen.SETTINGS
    }]
  }, {
    items: [{
      icon: HelpCircle,
      label: 'Help Center',
      screen: Screen.HELP_CENTER
    }]
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="min-h-screen bg-gray-50 pb-24" data-id="element-1228">
      <Header title="Profile" showBack={false} data-id="element-1229" />

      {/* Mode Switcher */}
      {user && <div className="bg-white p-4 mb-4 shadow-sm" data-id="element-1230">
          <div className="flex items-center justify-between" data-id="element-1231">
            <div data-id="element-1232">
              <h3 className="font-bold text-gray-900" data-id="element-1233">Vendor Mode</h3>
              <p className="text-xs text-gray-500" data-id="element-1234">
                Switch to manage your store
              </p>
            </div>
            <button onClick={() => {
          toggleVendorMode();
          if (!isVendorMode) {
            resetTo(Screen.VENDOR_DASHBOARD);
          } else {
            resetTo(Screen.HOME);
          }
        }} className={`w-12 h-6 rounded-full transition-colors relative ${isVendorMode ? 'bg-primary' : 'bg-gray-200'}`} data-id="element-1235">
              <div className={`w-5 h-5 bg-white rounded-full absolute top-0.5 transition-transform shadow-sm ${isVendorMode ? 'translate-x-6' : 'translate-x-0.5'}`} data-id="element-1236" />
            </button>
          </div>
        </div>}

      <div className="bg-white p-6 flex items-center gap-4 mb-4 shadow-sm" data-id="element-1237">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center text-primary" data-id="element-1238">
          <User className="w-8 h-8" data-id="element-1239" />
        </div>
        <div className="flex-1" data-id="element-1240">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-1241">
            {user?.name || 'Guest User'}
          </h2>
          <p className="text-sm text-gray-500" data-id="element-1242">
            {user?.email || 'Login to sync data'}
          </p>
        </div>
        {user ? <button onClick={() => navigate(Screen.EDIT_PROFILE)} className="text-sm font-bold text-primary bg-primary/10 px-4 py-2 rounded-lg" data-id="element-1243">
            Edit
          </button> : <button onClick={() => navigate(Screen.LOGIN)} className="text-sm font-bold text-primary bg-primary/10 px-4 py-2 rounded-lg" data-id="element-1244">
            Login
          </button>}
      </div>

      <div className="space-y-4" data-id="element-1245">
        {menuGroups.map((group, idx) => <div key={idx} className="bg-white shadow-sm" data-id="element-1246">
            {group.items.map((item, itemIdx) => {
          const Icon = item.icon;
          return <button key={item.label} onClick={() => navigate(item.screen)} className={`w-full flex items-center justify-between p-4 bg-white active:bg-gray-50 transition-colors ${itemIdx !== group.items.length - 1 ? 'border-b border-gray-50' : ''}`} data-id="element-1247">
                  <div className="flex items-center gap-3" data-id="element-1248">
                    <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center text-gray-600" data-id="element-1249">
                      <Icon className="w-4 h-4" data-id="element-1250" />
                    </div>
                    <span className="font-medium text-gray-700" data-id="element-1251">
                      {item.label}
                    </span>
                  </div>
                  <ChevronRight className="w-5 h-5 text-gray-400" data-id="element-1252" />
                </button>;
        })}
          </div>)}

        {user && <div className="bg-white shadow-sm mt-6" data-id="element-1253">
            <button onClick={handleLogout} className="w-full flex items-center gap-3 p-4 bg-white active:bg-gray-50 transition-colors text-error" data-id="element-1254">
              <div className="w-8 h-8 rounded-full bg-error/10 flex items-center justify-center" data-id="element-1255">
                <LogOut className="w-4 h-4" data-id="element-1256" />
              </div>
              <span className="font-bold" data-id="element-1257">Log Out</span>
            </button>
          </div>}
      </div>
    </motion.div>;
}